/**
 * The server's clock, as seen from this browser.
 *
 * Round timestamps (`closesAt`, `betsCloseAt`) are the server's instants, so
 * counting down against a raw `Date.now()` is only right when the player's PC
 * clock is right. A PC ten seconds slow showed 00:10 left on a round the server
 * had already drawn, then 05:10 on the next one.
 *
 * Every socket frame carries the server's `ts`. Network delay only ever makes a
 * sample look earlier than the truth, so the largest offset seen is the best.
 */
let offset = 0;
let synced = false;

export const serverNow = () => Date.now() + offset;

/** `reset` on a fresh connection, so a corrected PC clock is picked up again. */
export const syncServerClock = (serverMs: unknown, reset = false) => {
  if (typeof serverMs !== "number" || !Number.isFinite(serverMs)) return;
  const sample = serverMs - Date.now();
  if (reset || !synced || sample > offset) offset = sample;
  synced = true;
};
